import { render } from "./InspecaoArquivos.vue?vue&type=template&id=4509f7aa&scoped=true&ts=true"
import script from "./InspecaoArquivos.vue?vue&type=script&lang=ts"
export * from "./InspecaoArquivos.vue?vue&type=script&lang=ts"

import "./InspecaoArquivos.vue?vue&type=style&index=0&id=4509f7aa&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4509f7aa"]])

export default __exports__